import { render, staticRenderFns } from "./StartSession.vue?vue&type=template&id=748563f3&scoped=true"
import script from "./StartSession.vue?vue&type=script&lang=js"
export * from "./StartSession.vue?vue&type=script&lang=js"
import style0 from "./StartSession.vue?vue&type=style&index=0&id=748563f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748563f3",
  null
  
)

export default component.exports